/* src/app/ships/ship-profiles/ship-profiles.component.css */
.locations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 8px;
  padding: 8px;
}
/*# sourceMappingURL=ship-profiles.component.css.map */
